import { useEffect, useState } from 'react';
import { fetchProjects } from '../api/productsApi';
import AileronCta from '../components/sections/AileronCta';

export default function ProjectsPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let mounted = true;

    (async () => {
      try {
        const data = await fetchProjects();
        if (mounted) {
          setItems(Array.isArray(data) ? data : []);
        }
      } catch (err) {
        if (mounted) {
          setError(String(err?.message || err));
        }
      } finally {
        if (mounted) {
          setLoading(false);
        }
      }
    })();

    return () => {
      mounted = false;
    };
  }, []);

  return (
    <section className="mx-auto max-w-7xl px-6 py-10">
      <h1 className="text-3xl font-bold text-gray-900">Projects & Initiatives</h1>
      <p className="mt-2 max-w-3xl text-gray-600">
        A selection of products and automation initiatives aligned to operational efficiency, reliability, and measurable business outcomes.
      </p>

      {loading && <p className="mt-6 text-gray-600">Loading projects...</p>}
      {error && <p className="mt-6 text-red-600">{error}</p>}

      <div className="mt-8 grid gap-6 md:grid-cols-2">
        {items.map((item) => (
          <article key={item.id} className="rounded-2xl border border-gray-200 bg-white p-6">
            <div className="flex items-start justify-between gap-3">
              <h2 className="text-xl font-semibold text-gray-900">{item.title}</h2>
              <span className="rounded-md bg-gray-100 px-2 py-1 text-xs font-medium text-gray-700">
                {item.status}
              </span>
            </div>

            <p className="mt-3 text-gray-600">{item.shortDescription}</p>
            <p className="mt-3 text-sm text-gray-500">
              <span className="font-semibold text-gray-700">Category:</span> {item.category}
            </p>
            {item.type === 'initiative' ? (
              <>
                <p className="mt-1 text-sm text-gray-500">
                  <span className="font-semibold text-gray-700">Audience:</span> {item.audience}
                </p>
                <p className="mt-1 text-sm text-gray-500">
                  <span className="font-semibold text-gray-700">Focus:</span> {item.focus}
                </p>
                <p className="mt-1 text-sm text-gray-500">
                  <span className="font-semibold text-gray-700">Mission:</span> {item.mission}
                </p>
              </>
            ) : (
              <>
                <p className="mt-1 text-sm text-gray-500">
                  <span className="font-semibold text-gray-700">Industry:</span> {item.industry}
                </p>
                <p className="mt-1 text-sm text-gray-500">
                  <span className="font-semibold text-gray-700">Problem solved:</span> {item.problemSolved}
                </p>
                <p className="mt-1 text-sm text-gray-500">
                  <span className="font-semibold text-gray-700">Stack:</span> {(item.stack || []).join(', ')}
                </p>
              </>
            )}
            <p className="mt-3 text-sm text-gray-600">{item.aileronRelation}</p>

            <div className="mt-5">
              <a
                href={item.ctaUrl}
                target={item.ctaUrl?.startsWith('http') ? '_blank' : undefined}
                rel={item.ctaUrl?.startsWith('http') ? 'noreferrer' : undefined}
                className="inline-flex rounded-md bg-indigo-600 px-4 py-2 text-sm font-semibold text-white hover:bg-indigo-500"
              >
                {item.ctaLabel}
              </a>
            </div>
          </article>
        ))}
      </div>

      <AileronCta />
    </section>
  );
}
